<app-filter-panel [criteria]="searchCriteria">
    <ng-template #fields>
        <form [formGroup]="searchForm" (ngSubmit)="search()">
            <div class="row">
                <div class="mb-4">
                    <label for="companyName" class="form-label">Ragione sociale</label>
                    <input type="text" class="form-control" id="companyName" name="companyName"
                        formControlName="companyName" />
                </div>
            </div>

            <div class="d-flex justify-content-end  align-items-center col-12 m-2 gap-2">
                <button type="button" class="btn  btn-outline-secondary" (click)="clearFilter()">Cancella</button>
                <button type="submit" class="btn btn-primary">Cerca</button>
            </div>
        </form>
    </ng-template>
</app-filter-panel>
<div class="section-container">
    <div class="table-responsive">
        <table class="table caption-top table-hover table-striped">
            <caption>
                <button type="button" class="btn btn-primary" (click)="edit(0)"
                    *hasPermission="['ORGANIZATION_CONFIG_CREATE','ORGANIZATION_CONFIG_ALL', 'SAFESTREET_ADMIN']"><i
                        bTooltip title="Aggiungi" class="fa-solid fa-plus"></i></button>
                Risultati trovati: {{totalItems}}
            </caption>
            <thead>
                <tr>
                    <th scope="col" class="row-button-sm"></th>
                    <th scope="col" class="cursor-pointer" app-th-ordering [colName]="'companyName'"
                        [colValue]="'Ragione sociale'" [baseSearchCriteria]="searchCriteria"
                        (orderingClick)="ordering($event)"></th>
                    <th scope="col" class="cursor-pointer" app-th-ordering [colName]="'vat'" [colValue]="'P. IVA'"
                        [baseSearchCriteria]="searchCriteria" (orderingClick)="ordering($event)"></th>
                    <th scope="col" class="cursor-pointer" app-th-ordering [colName]="'city'" [colValue]="'Città'"
                        [baseSearchCriteria]="searchCriteria" (orderingClick)="ordering($event)"></th>
                    <th scope="col">Telefono</th>
                    <th scope="col" class="cursor-pointer" app-th-ordering [colName]="'email'" [colValue]="'Email'"
                        [baseSearchCriteria]="searchCriteria" (orderingClick)="ordering($event)"></th>
                    <th scope="col" class="row-button-sm">Autorizzato</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let guardian of guardians | paginate: {
                itemsPerPage: searchCriteria.pageSize,
                currentPage: searchCriteria.pageNumber,
                totalItems: totalItems } ">
                    <td>
                        <div class="d-flex justify-content-center  align-items-center gap-2">
                            <div class="cursor-pointer" (click)="edit(guardian.id!)"
                                *hasPermission="['ORGANIZATION_CONFIG_UPDATE','ORGANIZATION_CONFIG_ALL', 'SAFESTREET_ADMIN']">
                                <i bTooltip title="Modifica" class="fa-solid fa-pen"></i>
                            </div>
                            <div class="cursor-pointer" (click)="confirmOperation(guardian,'DEL')"
                                *hasPermission="['ORGANIZATION_CONFIG_DELETE','ORGANIZATION_CONFIG_ALL', 'SAFESTREET_ADMIN']">
                                <i bTooltip title="Elimina" class="fa-solid fa-trash"></i>
                            </div>
                        </div>
                    </td>
                    <td>{{guardian.companyName}}</td>
                    <td>{{guardian.vat}}</td>
                    <td>{{guardian.city}}</td>
                    <td>{{guardian.phone}}</td>
                    <td>{{guardian.email}}</td>
                    <td>
                        <div class="form-check form-switch">
                            <input class="form-check-input" type="checkbox" role="switch"
                                [checked]="guardian.authorizedByPrefect" disabled
                                [id]="'guardianChecked-'+guardian.id">
                            <label class="form-check-label" for="guardianChecked"></label>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
    <pagination-controls (pageChange)="pageChanged($event)" (pageBoundsCorrection)="pageChanged($event)"
        previousLabel="Precedente" nextLabel="Successiva" screenReaderPaginationLabel="Paginazione"
        screenReaderPageLabel="Pagina" screenReaderCurrentLabel="Vai alla pagina">
    </pagination-controls>
</div>
<app-confirm-alert [confirmationMessage]="confirmationMessage" [showConfirmationModal]="showConfirmationModal"
    (modalConfirm)="modalOperationExec()" (modalCancel)="cancelModalOperationExec()">
</app-confirm-alert>
